import nuwaveBlackImage from './assets/images/nav/nuwave_black.png';

export type Config = {
  environment: string;
  surveyUrl: string;
  api: {
    apiUrl: string;
    loginApiUrl: string;
    portalApiUrl: string;
    adminApiUrl: string;
    surveyApiUrl: string;
    wsApiUrl: string;
    mlApiUrl: string;
  };
  sentryDSN: string;
  imageSourceUrl: string;
  enableDevTools: boolean;
  enableNewApi: boolean;
};

export const AppConfig = {
  environment: process.env.NODE_ENV,
  surveyUrl: process.env.REACT_APP_SURVEY_URL,
  api: {
    apiUrl: process.env.NODE_ENV === 'development' ? '' : process.env.REACT_APP_API_URL,
    loginApiUrl:
      process.env.NODE_ENV === 'development' ? '/auth-api' : process.env.REACT_APP_LOGIN_API_URL,
    portalApiUrl:
      process.env.NODE_ENV === 'development'
        ? '/api/organization'
        : process.env.REACT_APP_PORTAL_API_URL,
    adminApiUrl:
      process.env.NODE_ENV === 'development' ? '/api/support' : process.env.REACT_APP_ADMIN_API_URL,
    surveyApiUrl:
      process.env.NODE_ENV === 'development' ? '/api/survey' : process.env.REACT_APP_SURVEY_API_URL,
    mlApiUrl:
      process.env.NODE_ENV === 'development' ? '/api/ml' : process.env.REACT_APP_SURVEY_API_URL,
    wsApiUrl: process.env.REACT_APP_WS_API_URL,
  },
  sentryDSN: process.env.REACT_APP_SENTRY_DSN,
  imageSourceUrl: nuwaveBlackImage,
} as Config;
